export default {
  // Get all student exams (main exams)
  GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST: "GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST",
  GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS: "GET_ADMIN_STUDENT_EXAMS_MAIN_SUCCESS",
  GET_ADMIN_STUDENT_EXAMS_MAIN_FAIL: "GET_ADMIN_STUDENT_EXAMS_MAIN_FAIL",

  // Redo exam
  REDO_EXAM_REQUEST: "REDO_EXAM_REQUEST",
  REDO_EXAM_SUCCESS: "REDO_EXAM_SUCCESS",
  REDO_EXAM_FAIL: "REDO_EXAM_FAIL",

  // Loading
  ADD_ADMIN_STUDENT_EXAMS_LOADING: "ADD_ADMIN_STUDENT_EXAMS_LOADING",

  // Student exam corrections
  GET_STUDENT_EXAMS_BY_EXAM_REQUEST: "GET_STUDENT_EXAMS_BY_EXAM_REQUEST",
  GET_STUDENT_EXAMS_BY_EXAM_SUCCESS: "GET_STUDENT_EXAMS_BY_EXAM_SUCCESS",
  GET_STUDENT_EXAMS_BY_EXAM_FAIL: "GET_STUDENT_EXAMS_BY_EXAM_FAIL",

  GET_CORRECTION_QUESTIONS_REQUEST: "GET_CORRECTION_QUESTIONS_REQUEST",
  GET_CORRECTION_QUESTIONS_SUCCESS: "GET_CORRECTION_QUESTIONS_SUCCESS",
  GET_CORRECTION_QUESTIONS_FAIL: "GET_CORRECTION_QUESTIONS_FAIL",

  CORRECT_STUDENT_EXAM_REQUEST: "CORRECT_STUDENT_EXAM_REQUEST",
  CORRECT_STUDENT_EXAM_SUCCESS: "CORRECT_STUDENT_EXAM_SUCCESS",
  CORRECT_STUDENT_EXAM_FAIL: "CORRECT_STUDENT_EXAM_FAIL",

  CLEAR_CORRECTION_QUESTIONS: "CLEAR_CORRECTION_QUESTIONS",

  GET_CORRECTED_QUESTIONS_REQUEST: "GET_CORRECTED_QUESTIONS_REQUEST",
  GET_CORRECTED_QUESTIONS_SUCCESS: "GET_CORRECTED_QUESTIONS_SUCCESS",
  GET_CORRECTED_QUESTIONS_FAIL: "GET_CORRECTED_QUESTIONS_FAIL",

  CLEAR_CORRECTED_QUESTIONS: "CLEAR_CORRECTED_QUESTIONS",

  GET_STUDENT_EXAM_REPORT_BY_CHAPTER_REQUEST: "GET_STUDENT_EXAM_REPORT_BY_CHAPTER_REQUEST",
  GET_STUDENT_EXAM_REPORT_BY_CHAPTER_SUCCESS: "GET_STUDENT_EXAM_REPORT_BY_CHAPTER_SUCCESS",
  GET_STUDENT_EXAM_REPORT_BY_CHAPTER_FAIL: "GET_STUDENT_EXAM_REPORT_BY_CHAPTER_FAIL",
};

